import gql from 'graphql-tag';






const updateVideoPublicLinkMutation = gql`
  mutation updateVideoPublicLink($videoId: String!, $input: VideoPublicLinkInput!) {
    updateVideoPublicLink(videoId: $videoId, input: $input) {
      videoId
      link
      expiryDate
    }
  }
`;

const updateVideoPublicLink = () => ({
  mutation: updateVideoPublicLinkMutation,
  module: 'video',
  buildVariables: ({ videoId, input


  }) => ({
    videoId,
    input
  })
});

export default updateVideoPublicLink;